import React from "react";
import "./nextSeasonApproval.scss";

const NextSeasonApproval = ({
  onClick,
  style = {},
  className = "",
  disabled = false,
  text,
  icon: IconComponent,
  width,
}) => {
  const dynamicStyle = disabled
    ? { color: "#000", cursor: "not-allowed" }
    : { color: "#b03a2e", cursor: "pointer" };

  return (
    <button
      type="button"
      style={{ width, ...dynamicStyle, ...style }}
      className={`check-season-completion-approve-next-season-btn ${className}`}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
    >
      {IconComponent && (
        <span className="check-season-completion-approve-next-season-btn-icon">
          <IconComponent
            fillColor={dynamicStyle.color}
            strokeColor={dynamicStyle.color}
          />
        </span>
      )}
      {text}
    </button>
  );
};

export default NextSeasonApproval;
